import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

import {
    Glyphicon,
    Icon,
    Panel,
    Text,
    Box,
} from 'reaxl';

const getButtonIcon = (data, uiContext) => {
    if (uiContext === 'trendingSearch') {
        return (
            <Icon
                icon={data.icon}
                label={data.heading}
            />
        );
    }

    return (
        <Glyphicon
            glyph={data?.icon ?? 'search'}
            className={clsx('text-accent text-size-500', { 'display-flex align-items-center': !!data?.icon })}
        />
    );

};

/**
 *  Describe the component
 *
 */
function SearchButton({
    data,
    className,
    maxWidth = 240,
    onClick = () => { },
    onKeyDown = () => { },
    index,
    uiContext = 'recentSearch',
    buttonColor = 'neutral-primary',
    buttonBorderColor = 'neutral-secondary',
    ...rest
}) {
    return (
        <Panel
            data-cmp="recentSearchButton"
            className={clsx('recent-search-card cursor-pointer display-flex flex-grow flex-column justify-content-between text-nowrap margin-bottom-0 bg-neutral-secondary border-0', className)}
            style={{
                maxWidth,
            }}
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onKeyDown}
            index={index}
            {...rest}
        >
            <Panel.Body className="display-flex padding-0">
                <Box
                    title={data.fullHeading}
                    className="text-size-400 display-inline-flex"
                    backgroundColor={buttonColor}
                    borderColor={buttonBorderColor}
                >
                    {getButtonIcon(data, uiContext)}
                    <div className="padding-left-2 display-inline-block text-left text-overflow">
                        <Text
                            componentClass="div"
                            weight="bold"
                            title={data.fullHeading}
                            className="text-overflow line-height-sm"
                        >
                            {data.heading}
                        </Text>
                        {data.subHeading
                            && (
                                <Text
                                    componentClass="div"
                                    size={300}
                                    color="subdued"
                                    title={data.fullSubHeading}
                                    className="text-overflow"
                                >
                                    {data.subHeading}
                                </Text>
                            )}
                    </div>
                </Box>

            </Panel.Body>
        </Panel>
    );
}

SearchButton.propTypes /* remove-proptypes */ = {
    /**
     * data object for recent search card
     */
    data: PropTypes.shape({
        /**
         * url for Shop Car link
         */
        url: PropTypes.string,
        /**
         * number of SRP results to display
         */
        totalCount: PropTypes.number,
        /**
         * truncated heading
         */
        heading: PropTypes.string,
        /**
         * full heading to be placed in title attr
         */
        fullHeading: PropTypes.string,
        /**
         * truncated subheading (description)
         */
        subHeading: PropTypes.string,
        /**
         * full subheading to be placed in title attr
         */
        fullSubHeading: PropTypes.string,
        /**
         * button background color
         */
        buttonColor: PropTypes.string,
        /**
         * button border color
         */
        buttonBorderColor: PropTypes.string,
    }).isRequired,
    /**
     * className to be passed to the root node
     */
    className: PropTypes.string,
    /**
     * The max width of the root container
     */
    maxWidth: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    /**
     * the context of whether the button is used for recent or trending searches
     */
    uiContext: PropTypes.string,
};

export default SearchButton;
